<template>
<div id="main">
    <div class="container4 ">
        <div class="container-fluid">
            <div class="text-center text-dark mb-5">
                <h5>SURVEY SYSTEM</h5>  
            </div>

            <div class="bg-light login-box ">
                <div class="card-header bg-white">
                    <i class="fa fa-lock fa-lg text-secondary" aria-hidden="true"></i>
                    <span class="m-0 text-secondary"> <b>ลงชื่อเข้าใช้งาน</b> </span>
                </div>
                <div class="card-body bg-light ">
                    <div class="form-group ">
                        <label class="small text-dark" ><b>USERNAME</b>   </label>
                        <input type="text" v-model="username" @keyup.enter="login" class="form-control shadow-sm form-control-lg input" placeholder="ระบุรหัสผู้ใช้">
                    </div>
                    <div class="form-group">
                      <label class="small text-dark"><b>PASSWORD</b>   </label>
                      <input type="password" v-model="password" @keyup.enter="login" class="form-control shadow-sm form-control-lg input"  placeholder="ระบุรหัสผ่าน">
                    </div>

                    <div class="row">
                      <button :disabled="isLogin" class="btn btn-primary btn-block pl-0 pr-0" @click="login">
                        <div v-if="isLogin">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> กรุณารอสักครู่...
                        </div>
                        <div v-if="!isLogin"><b>เข้าสู่ระบบ</b></div>
                      </button>
                    </div>

                </div>
            </div>
            
        </div>

    </div>

</div>
</template>
<script>
import Vue from 'vue';
import Api from './../api';

export default {
    data(){
        return {
        username:'',
        password:'',
        isLogin:false,
        }
    },

    created(){

    },

    methods:{
        login(){
            this.isLogin = true;
            var body = {
                username: this.username,
                password: this.password,
            }
            Api.login(body).then(res => {
                var {data} = res;
                if(data){
                  var user = data.result;
                  localStorage.setItem('user', JSON.stringify(user));
                  if (user.roleId=='admin' || user.roleId=='super' || user.roleId=='emp' ) {
                    this.$router.push({ name:'manageform' })
                  }
                }
            }).catch(err => {
                this.username = "";
                this.password = "";
                var {data} = err.response
                this.$swal(data.message, 'กรุณากรอก username และ password อีกครั้ง', "error");
                this.isLogin = false;
            })
        }
    }
}
</script>
<style scoped>
#main{
    height: 100%;
    background: #819ca9;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #546e7a, #819ca9);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #546e7a, #819ca9); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    /* #0072ff, #00c6ff
    #546e7a, #819ca9 */

 }
.login-box {

    margin: 0 auto;
    
    -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04) !important;
    border-radius: 4px
}

@media (min-width: 1200px) {
  .container4{
    padding-left: 20%;
    padding-right: 20%;
  }
  .login-box{
    width: 50% ;
  }
}
@media (min-width: 1024px) {
  .container4{
    padding-left: 10%;
    padding-right: 10%;
  }
  .login-box{
    width: 50% ;
  }
}
@media (min-width: 1300px) {
  .container4{
    padding-left: 20%;
    padding-right: 20%;
  }
  .login-box{
    width: 40% ;
  }
}

.container4 {
    width: 100%;

    height: auto !important;
   
    align-items: center !important;
    position: fixed;
    top: 50%;
    left: 50%;

    /* bring your own prefixes */
    transform: translate(-50%, -50%);
}
:root {
  /* generic */
  --gutterSm: 0.4rem;
  --gutterMd: 0.8rem;
  --gutterLg: 1.6rem;
  --gutterXl: 2.4rem;
  --gutterXx: 7.2rem;
  --colorPrimary400: #7e57c2;
  --colorPrimary600: #5e35b1;
  --colorPrimary800: #4527a0;
  --fontFamily: "Dosis", sans-serif;
  --fontSizeSm: 1.2rem;
  --fontSizeMd: 1.6rem;
  --fontSizeLg: 2.1rem;
  --fontSizeXl: 2.8rem;
  --fontSizeXx: 3.6rem;
  --lineHeightSm: 1.1;
  --lineHeightMd: 1.8;
  --transitionDuration: 300ms;
  --transitionTF: cubic-bezier(0.645, 0.045, 0.355, 1);
  
  /* floated labels */
  --inputPaddingV: var(--gutterMd);
  --inputPaddingH: var(--gutterLg);
  --inputFontSize: var(--fontSizeLg);
  --inputLineHeight: var(--lineHeightMd);
  --labelScaleFactor: 0.8;
  --labelDefaultPosY: 50%;
  --labelTransformedPosY: calc(
    (var(--labelDefaultPosY)) - 
    (var(--inputPaddingV) * var(--labelScaleFactor)) - 
    (var(--inputFontSize) * var(--inputLineHeight))
  );
  --inputTransitionDuration: var(--transitionDuration);
  --inputTransitionTF: var(--transitionTF);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-size: 10px;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  color: #455A64;
  background-color: #7E57C2;
  font-family: var(--fontFamily);
  font-size: var(--fontSizeMd);
  line-height: var(--lineHeightMd);
}

.Wrapper {
  flex: 0 0 80%;
  max-width: 80%;
}

.Title {
  margin: 0 0 var(--gutterXx) 0;
  padding: 0;
  color: #fff;
  font-size: var(--fontSizeXx);
  font-weight: 400;
  line-height: var(--lineHeightSm);
  text-align: center;
  text-shadow: -0.1rem 0.1rem 0.2rem var(--colorPrimary800);
}

.Input {
  position: relative;
}

.Input-text {
  display: block;
  margin: 0;
  padding: var(--inputPaddingV) var(--inputPaddingH);
  color: inherit;
  width: 100%;
  font-family: inherit;
  font-size: var(--inputFontSize);
  font-weight: inherit;
  line-height: var(--inputLineHeight);
  border: none;
  border-radius: 0.4rem;
  transition: box-shadow var(--transitionDuration);
}

.Input-text::placeholder {
  color: #B0BEC5;
}

.Input-text:focus {
  outline: none;
  box-shadow: 0.2rem 0.8rem 1.6rem var(--colorPrimary600);
}

.Input-label {
  display: block;
  position: absolute;
  bottom: 50%;
  left: 1rem;
  color: #fff;
  font-family: inherit;
  font-size: var(--inputFontSize);
  font-weight: inherit;
  line-height: var(--inputLineHeight);
  opacity: 0;
  transform: 
    translate3d(0, var(--labelDefaultPosY), 0)
    scale(1);
  transform-origin: 0 0;
  transition:
    opacity var(--inputTransitionDuration) var(--inputTransitionTF),
    transform var(--inputTransitionDuration) var(--inputTransitionTF),
    visibility 0ms var(--inputTransitionDuration) var(--inputTransitionTF),
    z-index 0ms var(--inputTransitionDuration) var(--inputTransitionTF);
}

.Input-text:placeholder-shown + .Input-label {
  visibility: hidden;
  z-index: -1;
}

.Input-text:not(:placeholder-shown) + .Input-label,
.Input-text:focus:not(:placeholder-shown) + .Input-label {
  visibility: visible;
  z-index: 1;
  opacity: 1;
  transform:
    translate3d(0, var(--labelTransformedPosY), 0)
    scale(var(--labelScaleFactor));
  transition:
    transform var(--inputTransitionDuration),
    visibility 0ms,
    z-index 0ms;
}
</style>
